import React from "react";
import MyTickets from "./HelpTabs/MyTickets";
import Option2 from "./HelpTabs/Option2";
import Option3 from "./HelpTabs/Option3";
import Option4 from "./HelpTabs/Option4";
import { NewTab, PageTabAdv } from "../../../components";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Help = () => { 

    const { userData: loginUserData } = useLoginUser();
    const moduleNumber = loginUserData?.role?.module;
    // const isBenchUser = BENCH_USER_MODULE===moduleNumber; 
  const helpMenus = [
    {
      title: "My Tickets",
      page: <MyTickets />,
      type: "main",
      id: "my_tickets",
    },
    {
      title: "Option 2",
      page: <Option2 />,
      type: "main",
      id: "option_2",
    },
    {
      title: "Option 3",
      page: <Option3 />,
      type: "main",
      id: "option_3",
    },
    {
      title: "Option 4",
      page: <Option4 />,
      type: "main",
      id: "option_4",
    },
  ];
  return (
  moduleNumber ===4?

 <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Help
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>

:
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={helpMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="help"
      />
    </div>


  );
};

export default Help;
